module.exports = __webpack_public_path__ + "img/ico_home.336bf63b.svg";